/**
 * @module
 * @name PrivacyPolicy
 */
export default {
  name: 'PrivacyPolicy',
  methods: {
  },
  mounted() {
  }
}
